export interface FantasyRateRow {
    Total: number;
    AthleteId: number;
    GAthleteId: string;
    BattleId: number;
    Points: number;
    Odd: number;
    FirstName: string;
    LastName: string;
    CountryId: number;
    PhotoUrl: string,
    BattleCount: number,
    SelectedUserCards: number[],
    AdPoints: DistributionPoint[],
    WinPoints: DistributionPoint[]
}

export interface FantasyInfo {
    EventId: number;
    Id: number;
    TournamentName: string;
    EventName: string;
    Points: FantasyRateRow[];
    Status: FantasyStatus,
    PlayersCount: number
}

export enum FantasyStatus {
    Calculated = 'Calculated', Open = 'Open', Closed = 'Closed'
}


export interface DistributionPoint {
    Id: string;
    Type: string;
    Key: number,
    Name: string;
    Points: number;
    Description: string;
}


export interface Card {
    id: number
    name: string
    fantasyPointId: number
    timeuse: string
    coef: number
    goldCoef: number
    silverCoef: number
    bronzeCoef: number
}

export interface UserCard {
    cardId: number
    id: number
    fantasyPointId: number
    timeuse: string
    name: string
    created: string
    status: CardStatus
    cardCoef: number,
    statusCoef: number,
    exCardData: number
}

export enum CardStatus {
    gold = 'gold',
    silver = 'silver',
    bronze = 'bronze'
}


export interface NewsSource {
    Id: number
    Name: string
    RSSUrl: string
    Type: string
    LogoUrl?: string
}

export interface VideoSource {
    id: number
    name: string
    channelId: string
    lang: string
    provider?: string
    logoUrl?: string
    accessToken?: string
}

export interface News {
    Id: number
    Title: string
    Url: string
    NewsDate: string
}

export interface MobileVideo {
    id: string
    title: string
    description: string
    sourceId: number
    sourceName: string
    publishedAt: string
    thumbnailUrl: string
}


export enum PromocodeType {
    subscription = "subscription",
    coins = "coins",
    card = "card",
}

export interface Promocode {
    id: number;
    code: string;
    startAt?: string | null;
    endAt?: string;
    maxClaimCount: number;
    type: PromocodeType;
    quantity?: number | null;
    cardId?: number | null;
    exCardData: number | null
    statusCard: string | null,
    claimCount: number
}

export interface Team {
    id: number;
    name: string;
    logoUrl: string;
    coins: number
    pts: number
    isOpen: boolean;
    chatUrl: string;
}

export interface UserTeamRead {
    id: number;
    userId: number;
    teamId: number;
    teamLogoUrl: string;
    email: string;
    firstName: string;
    lastName: string;
    role: 'admin' | 'user';
    approvedAt: string | null;
}

export interface UsersResponse {
    users: {
        id: number
        coins: number
        pts: number
        email: string
    }[],
}

export interface Collection {
    id: number,
    start_at: string,
    end_at: string
    completion_gift: string
    background_asset: string
    created_at: string
    updated_at: string
    name_ru?: string
    name_en?: string
    name_es?: string
    name_pt?: string
    background_asset_banner?: string
    reward_coins?: number | null
    reward_diamonds?: number | null
    reward_avatar_category_key?: string | null
    reward_avatar_item_level?: string | null
    count_card_gold_package_card?: number | null
}

export interface Pack  {
    id: number;
    name_en: string;
    name_ru: string;
    name_es?: string;
    name_pt?: string;
    background_color: string;
    collection_id: number | null;
    completion_gift: string | null;
    reward_athlete_card_id: number | null;
    reward_coins: number | null;
    reward_diamonds: number | null;
    reward_card_package_status: string | null;
    reward_avatar_category_key: string | null;
    reward_avatar_item_level: string | null;
    created_at: string | null;
    updated_at: string | null
    backgroundImage: string | null;
}


export interface PackCard  {
    id: number;
    pack_id: number | null;
    grid_row: number;
    grid_col: number;
    icon_png: string | null;
    description: string | null;
    created_at: string | null;
    updated_at: string | null;
    name_en: string | null;
    name_ru: string | null;
    name_es: string | null;
    name_pt: string | null;
    background_color: string | null;
}